import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { makeStyles } from '@mui/styles';

import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from "@fortawesome/pro-regular-svg-icons";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import CircularProgress from '@mui/material/CircularProgress';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import DialogX from './Dialog';

import {getConfigValue} from './Config';


const useStyles = makeStyles(theme => ({   
    
    outerRow: {
        fontFamily:'Mulish', 
        display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',
        // marginLeft: '.5em',
        // marginTop: '.5em',       
        backgroundColor:'#F3F3F3',
        // padding: '.5em',
        // paddingTop:'1em',
        width:'100%',
        borderRadius: '3px',
        fontSize: '9pt',
       

    },
    contactDetailsColumn: {
        display: 'flex', 
        flexDirection: 'column',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',  
        padding: '.5em',
    },
    contactsInfoLine: {
        marginBottom: '1em',
        fontSize: '8pt',
    },
    contactInfoButtonsColumn: {
        display: 'flex', 
        flexDirection: 'column',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',  
        padding: '.5em',               
    },
    contactsInfoButtons: {
        marginBottom: '1em',
        
    },
   
    usersList: {
        overflow: 'auto',
        maxHeight: 100,
        width: '400px',
      },
    contactsHeading: {
        fontSize: '12pt',
        marginLeft: '1.3em',
    },
    textField : {
        width: '120px',         
        fontSize: '8pt'
        
      }, 

    }));

    


const Contacts = (props) => {
    const classes = useStyles();
    var store = require('store')
     
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [address, setAddress] = useState('');
    const [areaCode, setAreaCode] = useState('');
    const [area, setArea] = useState('');
    const [mobilePhone, setMobilePhone] = useState('');
    const [email, setEmail] = useState('');
    
    const [contacts, setContacts] = useState([]);
    const [newContact, setNewContact] = useState({});
    
    const [selectedContactsIndex, setSelectedContactsIndex] = useState(0);

    const [dialogOpen, setDialogOpen] = useState();
    const [dialogText, setDialogText] = useState('');

    const [loadingButtons, setLoadingButtons] = useState({});

    const [isFetching, setIsFetching] = useState(false);
    
 
    const isLoading = (buttonName) => {
        return loadingButtons[buttonName];
    }

    const setLoading =(buttonName, isLoading) => {
        var ldnButtons = {...loadingButtons};
        ldnButtons[buttonName] = isLoading;
        setLoadingButtons(ldnButtons);        
    }

    const handleListItemClick = (index) => {
        setSelectedContactsIndex(index);

        displayContact(contacts[index]);
               
    }

    const displayContact = (contact) => {
        if (!contact)
            return; 

        setFirstName(contact.FirstName? contact.FirstName : '');
        setLastName(contact.LastName? contact.LastName : '');
        setAddress(contact.Address? contact.Address : '');
        setAreaCode(contact.AreaCode?  contact.AreaCode : '');
        setArea(contact.Area? contact.Area : '');
        setMobilePhone(contact.MobilePhone? contact.MobilePhone : '');
        setEmail(contact.Email? contact.Email : '');
    }

    const createNewContact =() => {
        var newContact = {};
        newContact.FirstName = "ny";
        newContact.LastName = "kontaktperson";
        newContact.IsNew=true;
        setNewContact(newContact);

        setContacts([newContact, ...contacts]);
        setSelectedContactsIndex(0);

        setFirstName('');
        setLastName('');
        setAddress('');
        setAreaCode('');
        setArea('');
        setMobilePhone('');
        setEmail('');
    }

    const getContacts = async () => {    
        setContacts([]);
        setIsFetching(true);

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/getContacts/${store.get("sessionToken")}`);            
        const json = await res.json();   
               
                 
        if (json["result"]=='success') {                        
            setContacts(json["contacts"]);

            setSelectedContactsIndex(0);
            displayContact(json["contacts"][0]);
            setIsFetching(false);

        }
        
    }

    const confirmDeleteContact = () =>{        
        setDialogText(`Er du sikkert på at du vil slette kontaktperson ${firstName} ${lastName}?`)        
        setDialogOpen(true);
    }

    const deleteContact = async (dialogResult) => {
        setLoading('deleteContact', true);

        if (dialogResult!==true) //dialog confirmed, true/false
            return;                

        const contact = contacts[selectedContactsIndex];

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/deleteContact/${store.get("sessionToken")}/${contact.Id}`);            
        const json = await res.json();   

        getContacts();           
        
        setLoading('deleteContact', false);
        
    }

    const upsertContact = async () => {

        setLoading('saveContact', true);

        const contact = contacts[selectedContactsIndex];

        contact.FirstName = firstName;
        contact.LastName = lastName;    
        contact.Address = address;  
        contact.AreaCode = areaCode;      
        contact.Area = area;    
        contact.MobilePhone = mobilePhone;    
        contact.Email = email;    

        setContacts([...contacts]); //force refresh

       
        const response = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/upsertContact/${store.get("sessionToken")}`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.          
            headers: {
              'Content-Type': 'application/json'             
            },            
            body: JSON.stringify(contact) // body data type must match "Content-Type" header
          });
          
          const json = await response.json(); // parses JSON response into native JavaScript objects

          getContacts(); //refresh list
        
          setLoading('saveContact', false);
    }

    const selectedContact = () => {
        if (contacts!= null && contacts.length!=0 && contacts[selectedContactsIndex])
            return contacts[selectedContactsIndex];
        else
            return {};         
    }

    const getFromIFS =(contact) => {
        if (contact.FromIFS)
            return '*';
        else 
            return '';
    }
    
    useEffect(() =>  { //run once on load
        getContacts();  
        
      },[props.doRefresh])

    return(              

        <div style={{marginTop: '.5em'}}>
        {dialogOpen && <DialogX dialogText={dialogText} onCompletionFunc={deleteContact} setDialogOpen={setDialogOpen}/> }
        

        <Accordion style={{backgroundColor: '#F3F3F3',marginLeft: '.5em'}} >
         <AccordionSummary style={{backgroundColor: '#F3F3F3'}}
          expandIcon={<ExpandMoreIcon />}                  
        >
          Kontaktpersoner ({contacts.length})
        </AccordionSummary>
         
        <AccordionDetails>        
        <div className={classes.outerRow}> 

            <div >                           

                <div>
                { isFetching && <CircularProgress /> }
                <List className={classes.usersList} dense={true}>
                    {contacts && contacts.map((item,index) => 
                        <ListItem selected={index==selectedContactsIndex} onClick={() => handleListItemClick(index)}>
                            <ListItemIcon>
                                <FontAwesomeIcon icon={faUser} />
                            </ListItemIcon>
                            <ListItemText
                                primary={ getFromIFS(item) + " "+ item.DisplayName}
                                secondary={false ? 'Secondary text' : null}
                            />
                        </ListItem>
                    )}               
                </List>
                </div>  
            
            </div>

            <div className={classes.contactDetailsColumn} >
                <div className={classes.contactsInfoLine}>
                    <TextField InputLabelProps={{shrink: true}} disabled={selectedContact().FromIFS} inputProps={{style: {fontSize: 12}}} style={{width: '80px'}}
                     value= {firstName} className={classes.textField} onChange={e => setFirstName(e.target.value)} 
                     variant="outlined" label="Fornavn" size='small'></TextField>
                    &nbsp;
                    <TextField InputLabelProps={{shrink: true}} disabled={selectedContact().FromIFS} inputProps={{style: {fontSize: 12}}} value={lastName} className={classes.textField} onChange={e => setLastName(e.target.value)} variant="outlined" label="Etternavn" size='small'></TextField>
                </div>

                <div className={classes.contactsInfoLine}>
                    <TextField InputLabelProps={{shrink: true}} disabled={selectedContact().FromIFS} inputProps={{style: {fontSize: 12}}} style={{width: '203px'}} value={address} className={classes.textField} onChange={e => setAddress(e.target.value)} variant="outlined" label="Adresse" size='small'></TextField>                   
                </div>

                <div className={classes.contactsInfoLine}>
                    <TextField InputLabelProps={{shrink: true}} disabled={selectedContact().FromIFS} inputProps={{style: {fontSize: 12}}} style={{width: '80px'}} value={areaCode} className={classes.textField} onChange={e => setAreaCode(e.target.value)} variant="outlined" label="Postnr" size='small'></TextField>
                    &nbsp;
                    <TextField InputLabelProps={{shrink: true}} disabled={selectedContact().FromIFS} inputProps={{style: {fontSize: 12}}} value={area} className={classes.textField} onChange={e => setArea(e.target.value)} variant="outlined" label="Poststed" size='small'></TextField>
                </div>
            </div>

            <div className={classes.contactDetailsColumn} >
                <div className={classes.contactsInfoLine}>
                    <TextField InputLabelProps={{shrink: true}} disabled={selectedContact().FromIFS} inputProps={{style: {fontSize: 12}}} style={{width: '200px'}} value={mobilePhone} className={classes.textField} onChange={e => setMobilePhone(e.target.value)} variant="outlined" label="Mobiltelefon" size='small'></TextField>                    
                </div>
                <div className={classes.contactsInfoLine}>
                    <TextField InputLabelProps={{shrink: true}} disabled={selectedContact().FromIFS} inputProps={{style: {fontSize: 12}}} style={{width: '200px'}} value={email} className={classes.textField} onChange={e => setEmail(e.target.value)} variant="outlined" label="Epost" size='small'></TextField>
                </div>

            </div>


            <div className={classes.contactInfoButtonsColumn}>
                <div className={classes.contactsInfoButtons} >
                    <LoadingButton loading={isLoading('saveContact')} disabled={selectedContact().FromIFS} onClick={upsertContact}
                    style={{minWidth: '70px'}} variant="contained" size='small'
                     color="primary" className={classes.primaryButton}>Lagre</LoadingButton>      
                </div>

                <div className={classes.contactsInfoButtons}>
                    <Button onClick={createNewContact}
                    style={{minWidth: '70px'}} variant="contained" size='small' 
                    color="primary" className={classes.primaryButton}>Ny</Button>      
                </div>
                
                <div className={classes.contactsInfoButtons}>
                    <LoadingButton loading={isLoading('deleteContact')} disabled={selectedContact().FromIFS} onClick={confirmDeleteContact}
                    style={{minWidth: '70px'}} variant="contained" size='small' 
                    color="primary" className={classes.primaryButton}>Slett</LoadingButton>      
                </div>
            </div>

        </div>

        </AccordionDetails>
        </Accordion>
        </div>
    )
};

export default Contacts;